<template>
  <router-view :pmsConnDetails="status"></router-view>
</template> 

<script>

import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";

export default {
  data: function () {
    return {
      pmsConnDetails: {},
      sub: "",
      loading: false,
      status: {},
    };
  },
  created: async function () {
      console.log("created in shell", this.$route);
    this.sub = this.$route.params.sub;
    await this.getStatus(this.sub);
  },
  methods: {
    getStatus: async function (sub) {
      this.loading = true;
      console.log("calling getstatus", sub);
      try {
        const result = await API.graphql(
          graphqlOperation(queries.getStatus, { sub: sub })
        );

        if (!result?.data?.getStatus) {
          this.handleResponseError("Get PMS Connector Details Error", result);
          this.status = {};
          return;
        }

        this.status = result.data.getStatus;
        this.status.sub = sub;
      } catch (err) {
        this.handleResponseError("Get PMS Connector Details Error", err);
      } finally {
        this.loading = false;
      }
    },
    async handleResponseError(operationDescription, response) {
      console.log("handleResponseError", response);
      const notifyResult = await this.$dialog.notify.error(
        operationDescription,
        {
          position: "top-right",
          timeout: 5000,
          actions: [{ text: "Info", "x-small": true, color: "secondary" }],
        }
      );

      if (notifyResult == "Info") {
        this.$dialog.error({
          text: JSON.stringify(response?.errors || response),
          title: operationDescription,
          icon: "mdi-error",
        });
      }
    },
  },
};
</script>